import React from "react";
import { Box, Typography } from "@mui/material";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell } from "recharts";
import { getComplianceFrameworkBadgeText } from "../../../assets/images/compliance/IconCompliance.jsx";

const ComplianceChart = ({ name, value, color, icon }) => {
  const frameworkBadgeText = getComplianceFrameworkBadgeText(name);
  return (
    <Box display="flex" alignItems="center" mb={2} sx={{ width: "100%" }}>
      <Box sx={{ flexGrow: 1, width: "100%" }} >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
          <Box display="flex" alignItems="center" gap={1}>
            {icon ? (
              <img
                src={icon}
                alt={name + " icon"}
                style={{ 
                  height: 16, 
                  width: "auto", 
                  maxWidth: 20
                }}
              />
            ) : frameworkBadgeText ? (
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 800,
                  color: "#1976d2",
                  letterSpacing: 0.4,
                  fontSize: "0.8rem",
                }}
              >
                {frameworkBadgeText}
              </Typography>
            ) : (
              <Typography
                variant="body2"
                sx={{ 
                  fontWeight: 800, 
                  color: "#1976d2", 
                  letterSpacing: 1,
                  fontSize: "0.875rem"
                }}
              >
                {name.charAt(0)}
              </Typography>
            )}
            <Typography
              variant="body2"
              sx={{ fontWeight: 500 }}
            >
              {name}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            sx={{ fontWeight: 600 }}
          >
            {value}%
          </Typography>
        </Box>
        <ResponsiveContainer width="100%" height={12}> {/* Adjusted bar height */}
          <BarChart
            data={[{ name, value, color }]}
            layout="vertical"
            barSize={12}
            margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
            maxBarSize={100} // Set the max bar size to represent 100%
          >
            <XAxis type="number" domain={[0, 100]} hide /> {/* Ensure the domain is 0-100 */}
            <YAxis type="category" dataKey="name" hide />
            <Bar dataKey="value" radius={[10, 10, 10, 10]}>
              <Cell fill={color} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default ComplianceChart;
